// extracted by mini-css-extract-plugin
var _1 = "ProfileResponsibleManagersWidgetForm-moduleformFieldsWrapper__Kaxud";
export { _1 as "formFieldsWrapper" }
